import { useState } from "react";
import { ILaboratoryModalProps } from "../types/modal";

import { useAppDispatch } from "../hooks/redux";
import { closeModalById, openModal } from "../features/modals";

import { useFormik } from "formik";
import axios from "axios";

import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  TextField,
  Stack,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

import laboratorySchema, { LaboratoryBase } from "../schemas/laboratory";
import PermissionGuard from "../components/PermissionGuard";
import PERMISSIONS from "../constants/permissions";
import MODALS from "../constants/modals";

const LaboratoryModal: React.FunctionComponent<ILaboratoryModalProps> = ({
  id,
  callback,
  initialValues,
}) => {
  const dispatch = useAppDispatch();

  const [isDeleting, setIsDeleting] = useState(false);

  const {
    values,
    dirty,
    handleChange,
    setFieldValue,
    handleSubmit,
    errors,
    resetForm,
    submitCount,
  } = useFormik<LaboratoryBase>({
    initialValues: {
      name: initialValues ? initialValues.name : "",
    },
    onSubmit: (values) => {
      axios
        .put(
          "/classifiers/laboratories",
          initialValues ? { _id: initialValues._id, ...values } : values
        )
        .then(() => {
          callback();
          handleClose();
        })
        .catch((err) => {
          console.log("err:", err);
        });
    },
    validationSchema: laboratorySchema,
  });

  const handleDelete = (id: string) => {
    setIsDeleting(true);
    axios
      .delete(`/classifiers/laboratories/${id}`)
      .then(() => {
        callback();
        handleClose();
      })
      .catch((err) => {
        console.log("err:", err);
        setIsDeleting(false);
      });
  };

  const handleClose = () => {
    dispatch(closeModalById(id));
  };

  return (
    <Dialog fullWidth={true} maxWidth="xs" open={true} onClose={handleClose}>
      <DialogTitle>{"_id" in values ? "Labot" : "Pievienot"} zobu tehniķi/laboratoriju</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <TextField
            id="name"
            label="Nosaukums"
            variant="standard"
            value={values.name}
            onChange={handleChange}
            error={Boolean(errors.name) && submitCount > 0}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <PermissionGuard permission={PERMISSIONS.DELETE_LABORATORIES}>
          {({ hasAccess }) => (
            <>
              {hasAccess && initialValues ? (
                <LoadingButton
                  loading={isDeleting}
                  onClick={() => {
                    setIsDeleting(true);
                    dispatch(
                      openModal({
                        type: MODALS.Approve,
                        title: "Vai tiešām dzēst zobu tehniķi/laboratoriju?",
                        message: "Zobu tehniķis/laboratorija tiks dzēsta neatgriezeniski.",
                        onApprove: () => {
                          handleDelete(initialValues._id);
                        },
                        onReject: () => {
                          setIsDeleting(false);
                        },
                      })
                    );
                  }}
                  color="error"
                  variant="outlined"
                >
                  Dzēst
                </LoadingButton>
              ) : null}
            </>
          )}
        </PermissionGuard>
        <Stack direction="row" spacing={2} justifyContent="flex-end" flex={1}>
          <Button onClick={handleClose}>Aizvērt</Button>
          <Button
            disabled={isDeleting}
            onClick={() => {
              handleSubmit();
            }}
            variant="contained"
          >
            {initialValues ? "Saglabāt" : "Pievienot"}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default LaboratoryModal;
